import { Dispatch, SetStateAction, ReactNode } from 'react';

interface IProps {
  setShowAlert: Dispatch<SetStateAction<boolean>>;
  statusPushNotification: {
    total: number;
    failed: number;
    success: number;
  };
}

// Função utilitária para pluralização com ReactNode
function getNotificationTextParts(
  value: number,
  singular: (count: number) => ReactNode,
  plural: (count: number) => ReactNode,
  none: ReactNode,
) {
  if (value === 0) return none;
  if (value === 1) return singular(value);
  return plural(value);
}

export const AlertPushNotification = ({
  statusPushNotification,
  setShowAlert,
}: IProps) => {
  return (
    <div
      className="alert alert-success alert-dismissible border-0 alert-additional fade show"
      role="alert"
    >
      <div className="alert-body">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          onClick={() => setShowAlert(false)}
        ></button>
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <i className="ri-notification-line fs-16 align-middle"></i>
          </div>
          <div className="flex-grow-1">
            <h5 className="alert-heading">Notificações enviadas.</h5>
            <p className="mb-0">
              {getNotificationTextParts(
                statusPushNotification?.total || 0,
                (count) => (
                  <>
                    Foi enviada <b>{count}</b> notificação.
                  </>
                ),
                (count) => (
                  <>
                    Foram enviadas um total de <b>{count}</b> notificações.
                  </>
                ),
                <>Nenhuma notificação enviada.</>,
              )}
            </p>
          </div>
        </div>
      </div>
      <div
        style={{
          borderRadius: '0',
        }}
        className="alert-content"
      >
        <p className="mb-0">
          <i className="ri-check-line align-middle me-1"></i>
          {getNotificationTextParts(
            statusPushNotification?.success || 0,
            (count) => (
              <>
                <b>{count}</b> Notificação enviada com sucesso.
              </>
            ),
            (count) => (
              <>
                <b>{count}</b> Notificações enviadas com sucesso.
              </>
            ),
            <>
              <b>Nenhuma</b> Notificação enviada com sucesso.
            </>,
          )}
        </p>
      </div>
      <div className="alert-content border-warning bg-warning">
        <p className="mb-0">
          <i className="ri-error-warning-line align-middle me-1"></i>
          {getNotificationTextParts(
            statusPushNotification?.failed || 0,
            (count) => (
              <>
                <b>{count}</b> Notificação falhou ao ser enviada.
              </>
            ),
            (count) => (
              <>
                <b>{count}</b> Notificações falharam ao serem enviadas.
              </>
            ),
            <>
              <b>Nenhuma</b> Notificação falhou ao ser enviada.
            </>,
          )}
        </p>
      </div>
    </div>
  );
};
